<div class="p-0!" tuiCell [class.flex-col]="vertical">
  <pxc-channel-avatar
    data-testid="channel-avatar"
    [channelType]="$safeNavigationMigration(channel?.type)"
    [channelUsers]="$safeNavigationMigration(channel?.users)"
    [size]="size" />

  <span tuiTitle [class.text-center!]="vertical">
    <span tuiTitle [class.text-center!]="vertical">
      <tui-line-clamp
        [content]="channelName"
        [lineHeight]="size === Size.SMALL ? 20 : 24"
        [linesLimit]="1"
        [ngClass]="{ 'max-w-24': vertical }" />

      <ng-template #channelName>
        <span class="text-sm font-medium">
          {{ channel | channelName }}
        </span>
      </ng-template>

      @if (showDetails) {
        <span class="text-xs font-normal" data-testid="date" [ngClass]="{ 'text-text-quaternary': !unreadsCount }">
          {{ date | date: 'shortDate' }}
        </span>
      }
    </span>

    @if (showDetails) {
      <span tuiSubtitle>
        <span
          class="line-clamp-1 w-full"
          data-testid="subtitle"
          [ngClass]="{
            'font-bold': unreadsCount,
            'text-text-tertiary': !unreadsCount,
          }">
          {{ channel | channelSubtitle }}
        </span>
        @if (unreadsCount) {
          <span
            appearance="custom"
            class="shrink-0 bg-foreground-error-primary!"
            data-testid="counter"
            size="m"
            tuiBadge>
            {{ unreadsCount }}
          </span>
        }
      </span>
    }
  </span>
</div>
